import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getRoleById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateRole } from "..";

const EditRole = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getBrand();
        else setLoading(false);
    }, [id]);

    const getBrand = async () => {
        try {
            const { data } = await getRoleById(id);
            setItem(data.role);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };

    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateRole from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_role' />
};

export default EditRole;